import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerStateService } from '../services/spinner-state.service';
import { APP } from '../models/app.model';

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerState = inject(SpinnerStateService);

  if (req.headers.has(APP.SPINNER_LOADER)) {
    const modifiedReq = req.clone({
      headers: req.headers.delete(APP.SPINNER_LOADER)
    });

    spinnerState.show();

    return next(modifiedReq).pipe(
      finalize(() => {
        spinnerState.hide();
      })
    );
  }

  return next(req);
};
